import classnames from 'classnames/bind';
import Modal from '@common/modal';
import CloseButton from '@common/closeButton';
import React from 'react';
import styles from './privacyPolicyAgreementModal.module.scss';
import { CommonButton } from '@components/pass/interview/practice/common/button';
import TermsDto from '@domain/rs/terms/TermsRs';

const cx = classnames.bind(styles);

interface Props {
  visible: boolean;
  termsData: TermsDto | null;
  isUseScrollHidden?: boolean;

  onClose(): void;
  onOk(): void;
}

const PrivacyPolicyAgreementModal = (props: Props) => {
  const { visible, termsData, isUseScrollHidden = true } = props;

  const handleCloseClick = () => {
    props.onClose();
  };

  const handleConfirmClick = () => {
    props.onOk();
  };

  if (!termsData) return null;

  return (
    <Modal visible={visible} dimmed={true} onClickBg={props.onClose} isUseScrollHidden={isUseScrollHidden}>
      <div className={cx('privacyPolicyLayer')}>
        <div className={cx('header')}>
          <div className={cx('btnCloseWrap')}>
            <CloseButton className={cx('btnClose')} onClick={handleCloseClick} />
          </div>
          <div className={cx('title')}>{termsData.title}</div>
        </div>
        <div className={cx('privacyPolicyWrap')}>
          <div className={cx('privacyPolicyText')} dangerouslySetInnerHTML={{ __html: termsData.contents }} />
        </div>
        <div className={cx('btnConfirmWrap')}>
          <CommonButton type={'green'} onClick={handleConfirmClick}>
            동의하고 시작하기
          </CommonButton>
        </div>
      </div>
    </Modal>
  );
};

export default PrivacyPolicyAgreementModal;
